'use strict';

import './component.scss';

/**
 * Source: https://stackoverflow.com/a/41601290/5918677
 * Usage: add "data-fixed-scroll-on-mobile" (the selector) attribute to the fixed element.
 */

const SELECTOR = "data-scroll-fixed-ios";

class ScrollFixedElementOnIOS {
    constructor(overlay) {
        this.element = overlay;
        this._clientY = null;

        this.init();
    }

    init() {
        this.attachTouchListeners();
    }

    attachTouchListeners() {
        this.element.addEventListener('touchstart', this.onTouchStart.bind(this), false);
        this.element.addEventListener('touchmove', this.onTouchMove.bind(this), false);
    }

    onTouchStart(e) {
        if (e.targetTouches.length === 1) {
            // detect single touch
            this._clientY = e.targetTouches[0].clientY;
        }
    }

    onTouchMove(e) {
        if (e.targetTouches.length === 1) {
            // detect single touch
            this.disableRubberBand(e);
        }
    }

    disableRubberBand(e) {
        let clientY = e.targetTouches[0].clientY - this._clientY;

        if (this.element.scrollTop === 0 && clientY > 0) {
            // element is at the top of its scroll
            e.preventDefault();
        }

        if (this.isOverlayTotallyScrolled() && clientY < 0) {
            // element is at the top of its scroll
            e.preventDefault();
        }
    }

    isOverlayTotallyScrolled() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
        return this.element.scrollHeight - this.element.scrollTop <= this.element.clientHeight;
    }
}

function init() {
    let overlays = document.querySelectorAll('[' + SELECTOR + ']');
    for (let i = 0; i < overlays.length; i++) {
        new ScrollFixedElementOnIOS(overlays[i]);
    }
}

window.addEventListener('DOMContentLoaded', init);

export default { init };